import React, { useState } from "react";
import DashboardLayout from "src/components/layout/dashboard/Layout";
import { Facebook, Linkedin, Instagram, Edit3, X } from "lucide-react";
import Modal from "../../components/ui/Modal";
import PageHeader from "src/components/common/PageHeader";
import Card from "src/components/common/card/Card";

const ProfilePage = () => {
  const [openModal, setOpenModal] = useState<null | "personal" | "address">(
    null
  );

  const user = {
    firstName: "Venugopal",
    lastName: "S",
    role: "Senior Software Engineer",
    email: "venugopal@invyntra.in",
    phone: "+91 98765 43210",
    bio: "Frontend Developer @ Invyntra",
    country: "India",
    cityState: "Bengaluru, Karnataka",
    postal: "560034",
    taxId: "INAB123456",
    avatar: "https://i.pravatar.cc/100?img=12",
  };

  return (
    <DashboardLayout
      meta={{
        title: "Profile | Invyntra",
        description:
          "Manage and update your personal profile information and settings.",
        keywords: "plans, products, invoices, inventory, invyntra",
      }}
    >
      <div className="space-y-4">
        {/* Header */}
        <PageHeader
          title="Profile"
          breadcrumbData={[
            { label: "Home", path: "/app/dashboard" },
            { label: "Profile", path: "/app/profile" },
          ]}
        />

        {/* Profile Header */}
        <Card>
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center space-x-4">
              <img
                src={user.avatar}
                alt={user.firstName}
                className="h-16 w-16 rounded-full object-cover"
              />
              <div>
                <h2 className="text-lg font-semibold text-gray-800">
                  {user.firstName} {user.lastName}
                </h2>
                <p className="text-sm text-gray-500">
                  {user.role} | {user.cityState}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-3 mt-4 md:mt-0">
              <a
                href="#"
                className="border p-2 rounded-full hover:bg-indigo-50"
              >
                <Facebook size={16} />
              </a>
              <a
                href="#"
                className="border p-2 rounded-full hover:bg-indigo-50"
              >
                <Linkedin size={16} />
              </a>
              <a
                href="#"
                className="border p-2 rounded-full hover:bg-indigo-50"
              >
                <Instagram size={16} />
              </a>

              <button
                onClick={() => setOpenModal("personal")}
                className="flex items-center space-x-1 border rounded-md px-3 py-1.5 text-sm hover:bg-indigo-50 transition"
              >
                <Edit3 size={14} />
                <span>Edit</span>
              </button>
            </div>
          </div>
        </Card>

        {/* Personal Information */}
        <Card>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-800">
              Personal Information
            </h3>
            <button
              onClick={() => setOpenModal("personal")}
              className="flex items-center space-x-1 border rounded-md px-3 py-1.5 text-sm hover:bg-indigo-50 transition"
            >
              <Edit3 size={14} />
              <span>Edit</span>
            </button>
          </div>

          <div className="grid md:grid-cols-2 gap-y-4 text-sm">
            <div>
              <p className="text-gray-500">First Name</p>
              <p className="font-medium">{user.firstName}</p>
            </div>
            <div>
              <p className="text-gray-500">Last Name</p>
              <p className="font-medium">{user.lastName}</p>
            </div>
            <div>
              <p className="text-gray-500">Email address</p>
              <p className="font-medium">{user.email}</p>
            </div>
            <div>
              <p className="text-gray-500">Phone</p>
              <p className="font-medium">{user.phone}</p>
            </div>
            <div className="md:col-span-2">
              <p className="text-gray-500">Bio</p>
              <p className="font-medium">{user.bio}</p>
            </div>
          </div>
        </Card>

        {/* Address Section */}
        <Card>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-800">Address</h3>
            <button
              onClick={() => setOpenModal("address")}
              className="flex items-center space-x-1 border rounded-md px-3 py-1.5 text-sm hover:bg-indigo-50 transition"
            >
              <Edit3 size={14} />
              <span>Edit</span>
            </button>
          </div>

          <div className="grid md:grid-cols-2 gap-y-4 text-sm">
            <div>
              <p className="text-gray-500">Country</p>
              <p className="font-medium">{user.country}</p>
            </div>
            <div>
              <p className="text-gray-500">City / State</p>
              <p className="font-medium">{user.cityState}</p>
            </div>
            <div>
              <p className="text-gray-500">Postal Code</p>
              <p className="font-medium">{user.postal}</p>
            </div>
            <div>
              <p className="text-gray-500">TAX ID</p>
              <p className="font-medium">{user.taxId}</p>
            </div>
          </div>
        </Card>
      </div>

      {/* ===== MODALS (UI Only) ===== */}

      {/* Personal Info Modal */}
      <Modal
        open={openModal === "personal"}
        onClose={() => setOpenModal(null)}
        title="Edit Personal Information"
      >
        <form className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium">First Name</label>
              <input
                type="text"
                defaultValue={user.firstName}
                className="border rounded-md w-full px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Last Name</label>
              <input
                type="text"
                defaultValue={user.lastName}
                className="border rounded-md w-full px-3 py-2 text-sm"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium">Email</label>
            <input
              type="email"
              defaultValue={user.email}
              className="border rounded-md w-full px-3 py-2 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Phone</label>
            <input
              type="text"
              defaultValue={user.phone}
              className="border rounded-md w-full px-3 py-2 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Bio</label>
            <textarea
              defaultValue={user.bio}
              className="border rounded-md w-full px-3 py-2 text-sm"
            ></textarea>
          </div>
          <div className="flex justify-end space-x-2 pt-2">
            <button
              type="button"
              onClick={() => setOpenModal(null)}
              className="border px-4 py-2 rounded-md text-sm"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-indigo-600 text-white px-4 py-2 rounded-md text-sm"
            >
              Save
            </button>
          </div>
        </form>
      </Modal>

      {/* Address Modal */}
      <Modal
        open={openModal === "address"}
        onClose={() => setOpenModal(null)}
        title="Edit Address Information"
      >
        <form className="space-y-4">
          <div>
            <label className="block text-sm font-medium">Country</label>
            <input
              type="text"
              defaultValue={user.country}
              className="border rounded-md w-full px-3 py-2 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">City / State</label>
            <input
              type="text"
              defaultValue={user.cityState}
              className="border rounded-md w-full px-3 py-2 text-sm"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium">Postal Code</label>
              <input
                type="text"
                defaultValue={user.postal}
                className="border rounded-md w-full px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">TAX ID</label>
              <input
                type="text"
                defaultValue={user.taxId}
                className="border rounded-md w-full px-3 py-2 text-sm"
              />
            </div>
          </div>
          <div className="flex justify-end space-x-2 pt-2">
            <button
              type="button"
              onClick={() => setOpenModal(null)}
              className="border px-4 py-2 rounded-md text-sm"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-indigo-600 text-white px-4 py-2 rounded-md text-sm"
            >
              Save
            </button>
          </div>
        </form>
      </Modal>
    </DashboardLayout>
  );
};

export default ProfilePage;
